import get from 'lodash.get';

const getDomainPurchaseAvailable = (rootState) =>
  get(rootState, 'user.partnerData.properties.domainPurchaseAvailable', false);

export default getDomainPurchaseAvailable;
